import enumsApi from './enums.api';
import {CLEnumType, CLEnumsMapper} from './enums.types';
import _mapValues from 'lodash/mapValues';
import {CancelToken} from 'axios';
import {toClientEnumMapper} from './enums.dataConverters';
import {clinchEnums} from '@cl/shared';
const {loadedEnumsSubject} = clinchEnums;

async function loadEnums(
  enumType: CLEnumType,
  cancelToken?: CancelToken,
): Promise<Record<string, CLEnumsMapper>> {
  if (!loadedEnumsSubject.data[enumType]) {
    const enumPromise = await enumsApi.get(enumType, cancelToken);
    loadedEnumsSubject.data[enumType] = _mapValues(enumPromise, toClientEnumMapper);
  }

  return loadedEnumsSubject.data[enumType];
}

const enumsService = {
  loadEnums,
};

export default enumsService;
